import { ReactElement, useCallback, useEffect } from 'react'

import { ScreenTitle } from '../../components/screen-title/screen-title'
import { Flexbox } from '../../components/flexbox/flexbox'
import { StatsContainer } from '../../components/stats/stats-container'
import { StatsItem } from '../../components/stats/stats-item'
import { MyProfits } from '../../components/my-profits/my-profits'
import { useRecoilValue } from 'recoil'
import { loggedUserState } from '../../states/logged-user-state'
import { UserContext } from '../../contexts/user-context'
import { AccountContext, useAccountContext } from '../../contexts/account-context'
import { selectedAccountState } from '../../states/selected-account-id'
import { MyDeposits } from '../../components/my-deposits/my-deposits'
import moment from 'moment'
import { TotalProfitsStat } from '../../components/total-profits-stat/total-profits-stat'
import { TotalValueStat } from '../../components/total-value-stat/total-value-stat'
import { MyWithdrawals } from '../../components/my-withdrawals/my-withdrawals'

export const DashboardScreen = (): ReactElement => {
  const defaultCurrency = 'CZK '

  const user = useRecoilValue(loggedUserState)
  const account = useRecoilValue(selectedAccountState)

  const isEmpty = !account

  if (isEmpty) {
    return (
      <Flexbox isCol flex={1} className="mt-8">
        <div className="hero bg-base-200 pt-10 pb-10">
          <div className="hero-content text-center">
            <div className="max-w-md">
              <h1 className="text-5xl font-bold">Hello there</h1>
              <p className="py-6">
                You are currently without assigned account. Please, contact your assigned
                administrator at <strong>1101 Capital</strong> or you can contact us on
              </p>
              <a className="btn btn-primary" href="mailto:office@1101capital.com">
                office@1101capital.com
              </a>
            </div>
          </div>
        </div>
      </Flexbox>
    )
  }

  if (!account) {
    return (
      <Flexbox isCol flex={1}>
        <ScreenTitle title={'No account selected'} />
      </Flexbox>
    )
  }

  return (
    <UserContext.Provider value={user?.id || null}>
      <AccountContext.Provider value={account.id}>
        <Flexbox isCol alignItems="stretch" style={{ width: '100%' }}>
          <div className="font-sm mb-4 opacity-50">
            {user?.firstName} {user?.lastName}
          </div>
          <ScreenTitle title={account.name} />

          <div style={{ width: '100%' }}>
            <StatsContainer>
              <TotalValueStat />
              <TotalProfitsStat />
            </StatsContainer>
          </div>
          <Flexbox>
            <Flexbox isCol flex={1} className="mt-8">
              <MyProfits />
              <MyDeposits />
              <MyWithdrawals />
            </Flexbox>
          </Flexbox>
        </Flexbox>
      </AccountContext.Provider>
    </UserContext.Provider>
  )
}